module.exports = __webpack_public_path__ + "static/media/patchpanel_thumbnail.803ba135.png";


//////////////////
// WEBPACK FOOTER
// ./src/examples/patchpanel/patchpanel_thumbnail.png
// module id = 1001
// module chunks = 0